import { useState, useRef, useCallback, useEffect } from "react";
import { MoveHorizontal } from "lucide-react";

export function BeforeAfter({ before, after, beforeLabel = "Before", afterLabel = "After", className = "" }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const move = useCallback((clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  }, []);

  useEffect(() => {
    const up = () => (dragging.current = false);
    const mm = (e) => dragging.current && move(e.clientX);
    const tm = (e) => dragging.current && move(e.touches[0].clientX);
    window.addEventListener("mouseup", up);
    window.addEventListener("mousemove", mm);
    window.addEventListener("touchend", up);
    window.addEventListener("touchmove", tm, { passive: false });
    return () => {
      window.removeEventListener("mouseup", up);
      window.removeEventListener("mousemove", mm);
      window.removeEventListener("touchend", up);
      window.removeEventListener("touchmove", tm);
    };
  }, [move]);

  const placeholder = "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=80";
  const b = before || placeholder, a = after || placeholder;

  return (
    <div ref={ref} data-testid="before-after" className={`relative overflow-hidden select-none hair-border cursor-ew-resize ${className}`}
      onMouseDown={(e) => { dragging.current = true; move(e.clientX); }}
      onTouchStart={(e) => { dragging.current = true; move(e.touches[0].clientX); }}>
      <img src={a} alt={afterLabel} className="w-full h-full object-cover pointer-events-none" draggable={false} />
      <span className="absolute top-3 right-3 z-10 bg-black/70 text-white text-[11px] px-3 py-1 tracking-widest">{afterLabel.toUpperCase()}</span>
      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ width: `${pos}%` }}>
        <img src={b} alt={beforeLabel} className="absolute inset-0 h-full object-cover max-w-none pointer-events-none" style={{ width: ref.current?.offsetWidth || "100%" }} draggable={false} />
        <span className="absolute top-3 left-3 bg-[#C9A45C] text-black text-[11px] px-3 py-1 tracking-widest">{beforeLabel.toUpperCase()}</span>
      </div>
      <div className="absolute top-0 bottom-0 z-10" style={{ left: `${pos}%`, transform: "translateX(-50%)" }}>
        <div className="w-0.5 h-full bg-[#C9A45C]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#C9A45C] flex items-center justify-center shadow-lg">
          <MoveHorizontal size={18} className="text-black" />
        </div>
      </div>
    </div>
  );
}
